import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Popover as PopoverShadcn,
  PopoverContent,
  PopoverTrigger,
} from 'shadcn/components/popover';

/**
 *
 * @param {Object} props
 * @param {ReactNode} props.body
 * @param {string} props.className
 * @returns
 */
const Popover = (props) => {
  //! State
  const { children, body, className, onOpenChange } = props;
  const [open, setOpen] = useState(false);

  const handleOpenChange = (open) => {
    setOpen(open);
    onOpenChange?.(open);
  };

  return (
    <PopoverShadcn open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent className={className}>{body}</PopoverContent>
    </PopoverShadcn>
  );
};

Popover.propTypes = {
  children: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  className: PropTypes.string,
  onOpenChange: PropTypes.func,
};

Popover.defaultProps = {
  className: '',
  onOpenChange: undefined,
};

export default React.memo(Popover);
